import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Card} from '../../../card-container/card/card';
import {LoginService} from '../../../../../shared-modules/login/login.service';
import { MatDialog } from '@angular/material/dialog';
import {YearService} from '../../../../../shared-components/year/year.service';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {NavigationExtras, Router} from '@angular/router';
import {UserService} from '../../../../../shared-components/user/user.service';
import {CardUpcomingEvents} from './card-upcoming-events';
import * as moment from 'moment';
import * as _ from 'lodash';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {interval} from 'rxjs';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-upcoming-events-card',
    templateUrl: './upcoming-events-card.component.html',
    styleUrls: ['./upcoming-events-card.component.css']
})

export class UpcomingEventsCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    eventsByMonth: EventMonth[] = [];
    upcomingEvents: CardUpcomingEvents[] = [];

    constructor(private userService: UserService, private loginService: LoginService, private dialog: MatDialog, private yearService: YearService, private studentService: StudentService, private studentSummaryService: StudentSummaryService, private router: Router) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getUpcomingEvents();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getUpcomingEvents() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardUpcomingEvents(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.userService.userType).subscribe(response => {
            if (response.ok) {
                this.upcomingEvents = _.cloneDeep(response.body);
                // Format Dates and times
                for (let i = 0; i < this.upcomingEvents.length; i++) {
                    if (this.upcomingEvents[i].StartTime !== '00:00:00') {
                        this.upcomingEvents[i].StartTime = moment(this.upcomingEvents[i].StartTime, 'HH:mm:ss').format('h:mm A');
                    } else {
                        this.upcomingEvents[i].StartTime = '';
                    }
                    if (this.upcomingEvents[i].EndTime !== '00:00:00') {
                        this.upcomingEvents[i].EndTime = moment(this.upcomingEvents[i].EndTime, 'HH:mm:ss').format('h:mm A');
                    } else {
                        this.upcomingEvents[i].EndTime = '';
                    }
                    this.upcomingEvents[i].EventStartDate = moment(this.upcomingEvents[i].EventStartDate, 'MM/DD/YYYY HH:mm:ss A').format('MM/DD/YYYY');
                    this.upcomingEvents[i].EventEndDate = moment(this.upcomingEvents[i].EventEndDate, 'MM/DD/YYYY HH:mm:ss A').format('MM/DD/YYYY');
                }
                // Get a list of months
                for (let i = 0; i < this.upcomingEvents.length; i++) {
                    const eMonth = moment(this.upcomingEvents[i].EventStartDate, 'MM/DD/YYYY').format('MMMM');
                    const eYear = moment(this.upcomingEvents[i].EventStartDate, 'MM/DD/YYYY').format('YYYY');
                    const event = [];
                    event.push((this.upcomingEvents[i]));
                    const monthEvent: EventMonth = {
                        month: eMonth,
                        year: eYear,
                        events: event
                    };
                    const mth = this.eventsByMonth.find(e => e.year == monthEvent.year && e.month == monthEvent.month);
                    if (mth) {
                        // Add the event to that month
                        mth.events.push(monthEvent.events[0]);
                    } else {
                        this.eventsByMonth.push(monthEvent);
                    }
                }
            }
        });
    }

    viewCalendarClick() {
        const navigationExtras: NavigationExtras = {
            // needs to be lower case view, day, week, month
            queryParams: {
                'selectedView': 'month'
            }
        };
        this.router.navigate(['/student360/calendar'], navigationExtras);
    }

    getDayString(event: CardUpcomingEvents) {
        const multiDayEvent = !moment(event.EventStartDate, 'MM/DD/YYYY').isSame(moment(event.EventEndDate, 'MM/DD/YYYY'), 'day');
        if (multiDayEvent) {
            // Check to see if the multi day event contains today's date
            if (moment().isBetween(event.EventStartDate, event.EventEndDate, 'day', '[]')) {
                return moment(new Date().toDateString(), 'ddd MMM DD YYYY hh:mm:ss').format('DD');
            } else {
                return moment(event.EventStartDate, 'MM/DD/YYYY').format('DD');
            }
        } else {
            return moment(event.EventStartDate, 'MM/DD/YYYY').format('DD');
        }
    }

    getWeekDayString(event: CardUpcomingEvents) {
        const multiDayEvent = !moment(event.EventStartDate, 'MM/DD/YYYY').isSame(moment(event.EventEndDate, 'MM/DD/YYYY'), 'day');
        if (multiDayEvent) {
            return moment(new Date().toDateString(), 'ddd MMM DD YYYY hh:mm:ss').format('dddd');
        } else {
            return moment(event.EventStartDate, 'MM/DD/YYYY').format('dddd');
        }
    }

    multiDayEvent(event: CardUpcomingEvents) {
        // check if the event is a multi day event
        if (event.EventStartDate == event.EventEndDate) {
            return false;
        } else {
            return true;
        }
    }

    getDateRangeString(event: CardUpcomingEvents) {
        const startDate = moment(event.EventStartDate, 'MM/DD/YYYY').format('MMM DD');
        const endDate = moment(event.EventEndDate, 'MM/DD/YYYY').format('MMM DD');
        return startDate + ' - ' + endDate;
    }

    getTimeLocationString(event: CardUpcomingEvents) {
        let eventStartTime = '';
        let eventEndTime = '';
        const location = event.EventLocation;
        if (event.StartTime) {
            eventStartTime = moment(event.StartTime, 'h:mm A').format('h:mm A');
        }
        if (event.EndTime) {
            eventEndTime = moment(event.EndTime, 'h:mm A').format('h:mm A');
        }
        if (eventStartTime && eventEndTime && location) { // Has StartTime, EndTime and Location
            return moment(eventStartTime, 'h:mm A').format('h:mm A') + ' - ' + eventEndTime + ', ' + location;
        }
        if (!eventStartTime && !eventEndTime && !location) { // Has no start time, end time or location
            return '';
        }
        if (eventStartTime && !eventEndTime && !location) { // Only a StartTime
            return eventStartTime;
        }
        if (!eventStartTime && eventEndTime && !location) { // Only a EndTime
            return 'Until ' + eventEndTime;
        }
        if (!eventStartTime && !eventEndTime && location) { // Only a Location
            return location;
        }
        if (eventStartTime && !eventEndTime && location) { // Has StartTime and Location
            return eventStartTime + ', ' + location;
        }
        if (!eventStartTime && eventEndTime && location) { // Has EndTime and Location
            return 'Until ' + eventEndTime + ', ' + location;
        }
        if (eventStartTime && eventEndTime && !location) { // Has StartTime and EndTime
            return moment(eventStartTime, 'h:mm A').format('h:mm A') + ' - ' + eventEndTime;
        }
    }

    hasTimeLocation(event: CardUpcomingEvents) {
        if (event.EndTime || event.StartTime || event.EventLocation) {
            return true;
        } else {
            return false;
        }
    }
}

export class EventMonth {
    month: string;
    year: string;
    events: CardUpcomingEvents[];
}
